import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddEditRoleGroupPage } from './add-edit-role-group.page';

const routes: Routes = [
  {
    path: '',
    component: AddEditRoleGroupPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddEditRoleGroupPageRoutingModule {}
